import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Flex } from 'pcln-design-system'
import ChipFilter from '../../atoms/ChipFilter'

const ChipCategoryGroupWrapper = Flex

const ChipFilterWrapper = styled(ChipFilter)`
  margin-left: ${(props) => props.theme.space[1]}px;
  margin-right: ${(props) => props.theme.space[1]}px;
  max-width: 100%;
`

const ChipCategoryGroup = (props) => {
  const { filters, className, filterNamePrefix, handleChange } = props

  const items = filters.map((filter, index) => {
    return (
      <ChipFilterWrapper
        chipId={`${filterNamePrefix}-${filter.value}-chip`}
        filter={filter}
        handleChange={handleChange}
        key={`${filter.value}-chip-${index}`}
      />
    )
  })
  return (
    <ChipCategoryGroupWrapper className={className} flexWrap='wrap' justifyContent='center' mt={2}>
      {items}
    </ChipCategoryGroupWrapper>
  )
}

ChipCategoryGroup.propTypes = {
  filters: PropTypes.array.isRequired, // one child per filterable item to control show-hides
  handleChange: PropTypes.func.isRequired,
  filterNamePrefix: PropTypes.string,
  className: PropTypes.string,
}

export default ChipCategoryGroup
